// extracted by mini-css-extract-plugin
export default {"highcharts":"antheRsCard_highcharts__0uz7q","card115":"antheRsCard_card115__UrCHt","highcharts-point":"antheRsCard_highcharts-point__HOD2t"};